"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CachedGetter = void 0;
var createCacheKey_1 = require("../utils/createCacheKey");
function CachedGetter(timeInSeconds) {
    if (timeInSeconds === void 0) { timeInSeconds = Infinity; }
    return function (target, propName, descriptor) {
        if (descriptor.get) {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            var origFn_1 = descriptor.get;
            descriptor.get = function () {
                var cacheKey = createCacheKey_1.createCacheKey(propName, []);
                var cachedValue = this.getFromCache(cacheKey);
                if (cachedValue) {
                    return cachedValue;
                }
                var result = origFn_1.call(this);
                this.setCache(cacheKey, result, timeInSeconds);
                return result;
            };
        }
        return descriptor;
    };
}
exports.CachedGetter = CachedGetter;
//# sourceMappingURL=CachedGetter.js.map